import { DateTime, IANAZone } from 'luxon';
import dateTimeMedium from '../filters/dateTimeMedium';

export const normalizeTimezoneIdentifier = (identifier: string): string => identifier?.replace(/ /g, '_');

export interface TimezoneOption {
    identifier: string;
    name: string;
}

export interface TimezoneSelectOption {
    label: string;
    value: string;
}

export const toTimezoneSelectOption = (timezone: TimezoneOption): TimezoneSelectOption => {
    const identifier = normalizeTimezoneIdentifier(timezone.identifier);
    const shortName = new Timezone(identifier).shortName;
    const label = `
        <div class="d-flex justify-content-between align-items-center">
            <div class="text-truncate">${timezone.name}</div>
            <small class="text-muted">${shortName}</small>
        </div>
    `;
    return { label, value: identifier };
};

export class Timezone {
    id: string;
    locale: string;
    zone: IANAZone;

    constructor(identifier: string, locale = 'en') {
        this.id = identifier;
        this.locale = locale;
        this.zone = new IANAZone(this.id);
    }

    get shortName(): string {
        try {
            return this.zone.offsetName(new Date().getTime(), {
                format: 'short',
                locale: this.locale,
            });
        } catch {
            return this.zone.name;
        }
    }

    static fromISO(iso: string, locale: string = 'en'): Timezone {
        const zone = DateTime.fromISO(iso, { setZone: true }).zone;
        return new Timezone(zone.name, locale);
    }

    getLocalTime(locale: string = 'en'): string {
        return dateTimeMedium(DateTime.local({ zone: this.id }).toString(), locale, this.id);
    }
}
